"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegerField = exports.DateField = void 0;

// @flow
// Wrapper for a number that we expect to always be an integer.
// We can't do static analysis to validate the input is an integer so sadly
// this will be a runtime error if it is violated.
class IntegerField {
  constructor(number) {
    if (!Number.isInteger(number)) {
      throw new Error("Number is not an integer: " + number);
    }

    this.number = number;
  }

  toJSON() {
    return this.number;
  }

} // Wrapper for a date that is serialized in the way the backend expects.
// Specifically, the backend requires 6 decimal digits of sub-second precision,
// while the default serialization only includes 3.


exports.IntegerField = IntegerField;

class DateField {
  constructor(date) {
    this.date = date;
  }

  toJSON() {
    return this.date.toISOString().replace("Z", "000Z");
  }

}

exports.DateField = DateField;